import { post, postExFile } from "@utils/httpUtil";
// 新建计划
export function operatePlanAdd(data, config) {
  return post(`/c/pc/operatePlan/add`, data, config);
}
// 分页查询计划列表
export function userOperationFindPageByCondition(data, config) {
  return post(`/c/pc/operatePlan/findPageByCondition`, data, config);
}
// 发布计划
export function userOperationPlanPublish(data, config) {
  return post(`/c/pc/operatePlan/publish`, data, config);
}
// 删除计划
export function userOperationPlanRemove(data, config) {
  return post(`/c/pc/operatePlan/remove`, data, config);
}
// 停止计划
export function userOperationPlanStop(data, config) {
  return post(`/c/pc/operatePlan/stop`, data, config);
}
// 修改计划
export function userOperationPlanUpdate(data, config) {
  return post(`/c/pc/operatePlan/update`, data, config);
}
// 导出计划列表
export function userOperationPlanExport(data, config) {
  return postExFile(`/c/pc/operatePlan/export`, data, config);
}
// 生成短链
export function userOperationSuoLink(data, config) {
  return post(`/c/pc/operatePlan/convert/suoLink`, data, config);
}
// 根据计划ID查询计划
export function userOperationFindById(data, config) {
  return post(`/c/pc/operatePlan/findById`, data, config);
}
// 获取条件下所有的用户Ids
export function newCommunityUserGetUserIdsByPageInfo(data, config) {
  return post(`/c/pc/community/user/getUserIdsByPageInfo`, data, config);
}
// 查询用户运营计划列表数据
export function newCommunityFindUserOperatePlanPageData(data, config) {
  return post(`/c/pc/operatePlan/findUserOperatePlanPageData`, data, config);
}
// 查询用户运营计划列表统计数据
export function newCommunityFindUserOperatePlanStatisticsData(data, config) {
  return post(`/c/pc/operatePlan/findUserOperatePlanStatisticsData`, data, config);
}
// 查询用户分群列表
export function newCommunityUserGroupingList(data, config) {
  return post(`/c/pc/userGrouping/pageList`, data, config);
}